<template>
  <div class="item-base">
    <div class="header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="header-content">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>典型案例</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <case-item v-for="(item,index) in ContentList" :item-data="item" :key="index+'s'"></case-item>
    </div>
    <el-pagination
      background
      class="page"
      :page-size="1"
      @current-change="handleCurrentChange"
      :total="parseInt(TotalPage)"
      layout="prev, pager, next"
    > </el-pagination>
  </div>
</template>

<script>
  import CaseItem from "./CaseItem";
  export default {
    name: "CaseBase",
    components: {CaseItem},
    data(){
      return{
        title:null,
        Page:{'pageSize':8,'pageNumber': 0 , 'type':1 ,  },
        ContentList:null,
        CurrentId:0,
        TotalPage:null,
      }
    },
    created() {
      this.GetData(this.Page)
    },
    methods:{
      GetData(data){
        this.$axios.post('/api/case/getList',data).then(res=>{
          console.log(res.data)
          this.ContentList=res.data.data.records;
          this.TotalPage=res.data.data.pages;
        })
      },
      ChangeId(index,code){
        this.CurrentId=index;
        this.Page.smallType=code;
        this.GetData(this.Page)
      },
      handleCurrentChange(index){
        this.Page.pageNumber=index;
        this.GetData(this.Page)
      }
    }
  }
</script>

<style lang="less" scoped>
.item-base{

  .header{
    height: 44px;
    background: #F6F7F8;
    .header-content{
      line-height: 44px;
      margin: 0 auto;
      width: 74.5%;
      /*padding:10px;*/
    }
  }
  .content{
    width: 74.5vw;
    margin: 0 auto;
    min-height: 80vh;
    .title{
      text-align: center;
      margin: 30px 0;
      span{
        height: 18px;
        font-size: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        line-height: 27px;
        margin: 0 10px;
      }
    }
  }
  .active{
    color: #ffffff;
    height: 35px;
    background: #188ACB;
    border-radius: 20px;
    padding: 3px 10px;
  }
  .page{
    text-align: center;
    margin: 60px 0;
  }
}
</style>